import type { AxiosInstance } from 'axios';
import type {
  ConfirmUploadRequest,
  MediaResponse,
  PresignedUploadRequest,
  PresignedUploadResponse,
} from './media.type.ts';

/**
 * media-service 엔드포인트(Gateway 경유). 앱별 endpoints 레지스트리에 복사하지 말 것.
 */
export const MEDIA_API_VERSION = '/v1';

export const MEDIA_ENDPOINTS = {
  presignedUrl: `${MEDIA_API_VERSION}/media/presigned-url`,
  confirm: `${MEDIA_API_VERSION}/media/confirm`,
  remove: (id: string) => `${MEDIA_API_VERSION}/media/${id}`,
  /** 조회용 signed URL — 검증 서류 미리보기/다운로드. */
  viewUrl: (id: string) => `${MEDIA_API_VERSION}/media/${id}/view-url`,
} as const;

/**
 * media-service 호출부. `useUploadMedia` 에 그대로 주입한다.
 *
 * billing 과 같은 이유로 팩토리다 — 두 앱의 apiClient 는 baseURL·onUnauthorized 가
 * 달라 인스턴스를 공유할 수 없지만, 호출부까지 복사하면 계약이 앱마다 갈라진다.
 */
export function createMediaApi(apiClient: AxiosInstance) {
  return {
    getPresignedUrl: (req: PresignedUploadRequest) =>
      apiClient
        .post<PresignedUploadResponse>(MEDIA_ENDPOINTS.presignedUrl, req)
        .then((r) => r.data),

    confirmUpload: (req: ConfirmUploadRequest) =>
      apiClient
        .post<MediaResponse>(MEDIA_ENDPOINTS.confirm, req)
        .then((r) => r.data),

    getViewUrl: (id: string) =>
      apiClient
        .get<{ url: string }>(MEDIA_ENDPOINTS.viewUrl(id))
        .then((r) => r.data),
  };
}

export type MediaApi = ReturnType<typeof createMediaApi>;
